import {
  Error,
  Configuration as OneHubConfigurationObject,
  Partner,
} from '@tribal-worldwide-london/fa-analytics';
import { GlobalStoreStateConfiguration } from '../stores/globalStore';
import {
  cubicCapacityToLitres,
  getEmissionsConsumptionValue,
  getNewCarsDepartment,
} from '../modules/utils/storeUtils';
import { Retailers } from '@tribal-worldwide-london/fa-retailer-service-vwg';

export const getAnalyticsConfigurationFromCarConfiguration = (
  configuration: GlobalStoreStateConfiguration
): OneHubConfigurationObject => {
  const fuelType =
    configuration?.pdbData?.technicalSpecifications?.engine?.fuelTypeName;

  const emissionsCombined =
    configuration.configData || configuration.stockData
      ? getEmissionsConsumptionValue(
        configuration,
        fuelType,
        'emissions',
        'combined'
      )
      : null;

  const consumptionCombined =
    configuration.configData || configuration.stockData
      ? getEmissionsConsumptionValue(
        configuration,
        fuelType,
        'consumption',
        'combined'
      )
      : null;

  const { derivative, technicalSpecifications, exterior, interior, pricing } =
    configuration.pdbData ?? {};

  const modelGearType = technicalSpecifications?.transmission.gearboxTypeName;
  const modelGearTypeModified = modelGearType && modelGearType != "Unspecified" ? modelGearType : null

  return {
    BodyTypeName: null,
    CarlineId: derivative?.modelId ?? null,
    CarlineName: derivative
      ? derivative?.modelTitle
      : null,
    CarlineIsRecommendation: null,
    SalesgroupId: derivative?.salesGroupId ?? null,
    SalesgroupName: null,
    SalesgroupIsRecommendation: null,
    EquipmentlineName: null,
    EquipmentlineIsRecommendation: null,
    ModelTrimFeatures: null,
    ModelName: `${derivative?.modelTitle} ${derivative?.title}`,
    ModelYear: derivative?.year.toString() ?? null,
    ModelModelVersion: null,
    ModelIsRecommendation: null,
    ModelDriveType: null,
    ModelGearType: modelGearTypeModified,
    EnginePowerHPKW: null,
    EngineFuelTypePrimary: fuelType ?? null,
    EngineFuelTypeNonPrimary: null,
    EngineCapacity:
      cubicCapacityToLitres(technicalSpecifications?.engine?.cubicCapacity) ??
      null,
    EmissionCo2CombinedPrimary: emissionsCombined?.value
      ? Number(emissionsCombined?.value)
      : null,
    ConsumptionCombinedPrimary: consumptionCombined?.value
      ? String(consumptionCombined?.value)
      : null,
    ConsumptionCombinedNonPrimary: null,
    EmissionConsumptionEfficiencyClass: null,
    EmissionConsumptionTestingMethod: null,
    ExteriorColorCode: exterior?.code ?? null,
    ExteriorColorName: exterior?.name ?? null,
    ExteriorColorIsRecommendation: null,
    InteriorColorCode: interior?.['upholstery-colour'] ?? null,
    InteriorColorName: interior?.title ?? null,
    InteriorColorIsRecommendation: null,
    WheelsBasicId: null,
    WheelsBasicName: null,
    Wheels_Basic_IsRecopmmendation: null,
    WheelsBasicSize: null,
    WheelsBasicType: null,
    PriceType: null,
    PriceTypeParameter: null,
    PriceRateCurrency: 'GBP',
    PriceRateType: null,
    PriceRateBasic: null,
    PriceRateAdditional: null,
    PriceRateTotal: null,
    PriceTotalCurrency: 'GBP',
    PriceTotalBasic: null,
    PriceTotalAdditional: null,
    PriceTotalTotal: pricing?.outstandingTotal ?? null,
    PriceCurrency: 'GBP',
    PriceBasis: null,
    PriceExterior: null,
    PriceOptions: null,
    PriceWheels: null,
    PriceTotalConfiguration: null,
    PriceRecommendedOptions: null,
    PriceCampaignID: null,
    PriceCampaignDescription: null,
    PriceCampaignValue: null,
    PriceCustomerType: null,
    ExtrasNumber: null,
    ExtrasList: null,
    OptionsNumber: null,
    OptionsList: null,
    Marketingcode: configuration?.marketingShortCode ?? null,
    VehicleBusinessModel: null,
    FocusItem: null,
    VehicleList: null,
    RemoteModelData: null,
  };
};

export const getAnalyticsPartnerFields = (
  retailers: Retailers[]
): Partner => {
  const retailerDepartment = getNewCarsDepartment(
    retailers[0]?.departments || []
  );

  return {
    informationBnr: retailers[0]?.dealerNumber ?? null,
    informationName: retailers[0]?.name ?? null,
    informationDepartment: retailerDepartment?.departmentType?.name ?? null,
    informationZIP: null,
    informationDistance: null,
    informationAvgRating: null,
    informationRegion: retailerDepartment?.district ?? null,
    informationType: null,
    informationBrand: null,
    informationCountry: null,
    SearchSearchTerm: null,
    SearchType: null,
    SearchNumberOfResults: null,
  };
};

export const getAnalyticsErrorFields = (error: Error): Error => {
  return {
    code: error.code,
    message: error.message,
    referringUrl: window.location.href,
  };
};
